export const fallbackLocale = (data: any, locale = "en", fallback = "en") => {
  if (data) {
    if (data[locale]) {
      return data[locale];
    }
    return data[fallback];
  }
  return data || "";
};

export const formatMoney = (number, currency = "idr", noTag = false) => {
  const formats = {
    'idr': { currency: 'idr', locale: 'id', fraction: 0 },
    'usd': { currency: 'usd', locale: 'en-US', fraction: 2 },
  }
  const format = formats[currency] || formats['idr'];
  try {
    const formated = new Intl.NumberFormat(format.locale, {
      style: noTag ? undefined : "currency",
      currency: format.currency,
      minimumFractionDigits: format.fraction,
    }).format(number);
    return formated
  } catch (e) {
    console.error(e)
    return number;
  }
};
